const state = {
    toasts: []
};

const getters = {
    toasts: state => state.toasts
};

const mutations = {
    setToasts: (state, data) => state.toasts = data
};

const actions = {
    onAddToast: (context, data) => { }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    strict: false
};